<template>
  <Page>
    <div class="page subscribe">
      <Title
        title="Subscribe for Interest"
        preheader="Campus Complex"
        shape="email"
        labelLeft="Potential"
        labelRight="Programs"
      ></Title>
      <div class="content">
        <div class="section">
          <transition name="formTransition">
            <div :class="['message', showSuccessClass]" v-if="showSuccess">
              <p class="heading">Thanks for your interest!</p>
              <p>Happy traversing.</p>
            </div>
            <div :class="['message', showErrorClass]" v-else-if="showError">
              <p class="heading">Oh no, there was an error.</p>
              <p>Please try submitting again.</p>
            </div>
            <form
              id="subscribeForm"
              name="emails"
              @submit="process"
              v-else
              :class="['form', showFormClass]"
            >
              <input type="hidden" name="form-name" value="emails" />
              <div class="form-section">
                <p class="label">You are a...</p>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="role"
                    :value="'learner'"
                    name="role"
                    id="role-learner"
                  />
                  <label for="role-learner">Learner</label>
                </div>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="role"
                    :value="'educator'"
                    name="role"
                    id="role-educator"
                  />
                  <label for="role-educator">Educator</label>
                </div>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="role"
                    :value="'campus-builder'"
                    name="role"
                    id="role-builder"
                  />
                  <label for="role-builder">Campus Builder</label>
                </div>
              </div>
              <div class="form-section">
                <p class="label">You are in...</p>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="location"
                    :value="'ny'"
                    name="location"
                    id="location-ny"
                  />
                  <label for="location-ny">New York City</label>
                </div>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="location"
                    :value="'dc'"
                    name="location"
                    id="location-dc"
                  />
                  <label for="location-dc">Washington, D.C.</label>
                </div>
                <div class="select-section">
                  <input
                    type="radio"
                    v-model="location"
                    :value="'other'"
                    name="location"
                    id="location-other"
                  />
                  <label for="location-other">Elsewhere</label>
                </div>
              </div>
              <input
                v-if="location == 'other'"
                id="location-custom"
                type="text"
                name="location-custom"
                class="name-input"
                placeholder="Location"
              />
              <input
                id="name"
                type="text"
                name="name"
                class="name-input"
                placeholder="Name"
              />
              <input
                id="email"
                type="email"
                name="email"
                class="email-input"
                placeholder="Email"
              />
              <button type="submit" class="button-bg">Subscribe</button>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "@/components/Page.vue";
import Title from "@/components/Title.vue";

export default {
  name: "Subscribe",
  components: {
    Page,
    Title,
  },
  data() {
    return {
      showSuccess: false,
      showError: false,
      showForm: true,
      location: null,
      role: null,
    };
  },
  computed: {
    showFormClass() {
      return this.showForm == true ? "show-form" : "";
    },
    showSuccessClass() {
      return this.showSuccess == true ? "show-success" : "";
    },
    showErrorClass() {
      return this.showError == true ? "show-error" : "";
    },
  },
  methods: {
    process(event) {
      event.preventDefault();
      let subscribeForm = document.getElementById("subscribeForm");
      let formData = new FormData(subscribeForm);
      console.log(formData);
      let body = new URLSearchParams(formData).toString();
      console.log(body);

      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      })
        .then((e) => {
          console.log(e);
          if (!e.ok) {
            this.showErrorMessage();
          } else {
            this.showSuccessMessage();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessage();
        });
    },
    showSuccessMessage() {
      this.showForm = false;
      this.showSuccess = true;
    },
    showErrorMessage() {
      this.showForm = false;
      this.showError = true;
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
.message {
  opacity: 0;
  pointer-events: none;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  width: 100%;
  text-align: center;
}

.message .heading {
  font-weight: bold;
  font-style: italic;
  margin: 0;
}

.message p {
  margin: 0;
}

.message.show-success {
  opacity: 1;
  pointer-events: all;
}

.message.show-error {
  opacity: 1;
  pointer-events: all;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 3rem;
  opacity: 0;
  pointer-events: none;
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
}

.form-section {
  display: flex;
  flex-direction: column;
  grid-gap: 1rem;
  width: 100%;
}

.form.show-form {
  opacity: 1;
  pointer-events: all;
}

.form input {
  background: var(--tan-02);
  border: 1.5px solid #f3e0c3;
  padding: 1.6rem;
  font-size: 2rem;
  font-family: "Scala";
  transition: all var(--motion-primary-duration) var(--motion-bubbly-bezier);
  border-radius: 12px;
  width: 100%;
}

.form input:focus {
  outline: 0;
  border: 1.5px solid var(--green-02);
}

.form .select-section {
  display: flex;
  flex-direction: row;
  grid-gap: 8px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  font-size: 2rem;
  font-family: "Scala";
  accent-color: var(--green-02);
  text-align: left;
}

.form .select-section input,
.form .select-section label {
  cursor: pointer;
}

.form .select-section input[type="radio"] {
  height: 2rem;
  width: 2rem;
  margin: 0;
}

.form .button-bg {
  width: fit-content;
  font-size: 2rem;
  font-family: "Scala";
  font-weight: bold;
  font-style: italic;
  color: #807D79;
}

.form .button-bg:hover {
  color: var(--green-02);
}

.form p.label {
  color: #807D79;
  text-align: left;
  width: 100%;
  font-size: 2rem;
  margin: 0;
}

.page.subscribe .section {
  margin-bottom: 14rem;
}

@media (max-width: 560px) {
  .form input,
  .form label,
  .form p.label {
    font-size: 2.4rem;
  }
}
</style>
